const menu = {
	'menu.home': 'Ana Sayfa',
	'menu.contract': 'Sözleşme',
	'menu.chatgpt': 'SohbetGPT',
	'menu.option.contract': 'Seçenek Sözleşmesi',
	'menu.option.ai': 'AI Yüksek Frekanslı Arbitraj',
	'menu.option.qr': 'Miktarsal Robot',
	'menu.option.ai.mall': 'AI Akıllı Alışveriş Merkezi',

	'menu.my.orders': 'Siparişlerim',
	'menu.stake': 'Stake',
	'menu.about': 'Hakkında',
	'menu.about.faq': 'SSS',
	'menu.serve': 'Hizmet Şartları',
	'menu.privacy': 'Gizlilik Politikası',
	'menu.token': 'Hızlı Token',
}

export default menu
